module.exports = "/_next/static/images/chi-6ca5d04c09cab79d513a2e4c8d63389e.jpg.webp";